import {
  SS_EMAIL,
  SS_REF_HASH_ID,
} from "../../../presentation/resources/secureStorageManager";
import secureStorage from "../../../utility/secureStorage";
import {
  ApiDeleteServiceWrapper,
  ApiPostServiceWithoutAuthenticationWrapper,
  ApiPostServiceWrapper,
  ApiPutServiceWrapper,
} from "../wrapperService";
import { API_ENDPOINT } from "./ApiEndPoint";

export const ApiRequestPost = {
  authenticate: (username, password) => {
    return new Promise((resolve, reject) => {
      return ApiPostServiceWithoutAuthenticationWrapper({
        url: API_ENDPOINT.basePath + "authenticate",
        headers: {},
        body: {
          username,
          password,
        },
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  vanTransactionHistory: (page, size, dateRange = "", utr = "", van = "") => {
    return new Promise((resolve, reject) => {
      const refHashId = secureStorage.getItem(SS_REF_HASH_ID);
      ApiPostServiceWrapper({
        url: API_ENDPOINT.basePath + "client/transaction",
        headers: {},
        body: {
          page,
          size,
          beneAccountNo: van,
          transferUniqueNo: utr,
          dateRange,
          clientHashId: refHashId,
          commissionType: "payIn",
        },
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  vanTransactionHistoryPayOut: (
    page,
    size,
    dateRange = "",
    utr = "",
    van = ""
  ) => {
    return new Promise((resolve, reject) => {
      const refHashId = secureStorage.getItem(SS_REF_HASH_ID);
      ApiPostServiceWrapper({
        url: API_ENDPOINT.basePath + "client/transaction",
        headers: {},
        body: {
          page,
          size,
          beneAccountNo: van,
          transferUniqueNo: utr,
          dateRange,
          clientHashId: refHashId,
          commissionType: "payOut",
        },
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  vanLedgerHistory: (page, size, dateRange, type = "", id = "") => {
    return new Promise((resolve, reject) => {
      const refHashId = secureStorage.getItem(SS_REF_HASH_ID);
      ApiPostServiceWrapper({
        url: API_ENDPOINT.basePath + "client/ledgers",
        headers: {},
        body: {
          page,
          size,
          type: type?.toUpperCase(),
          txnId: id,
          dateRange,
          clientHashId: refHashId,
        },
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  login: (username, password) => {
    return new Promise((resolve, reject) => {
      ApiPostServiceWrapper({
        url: API_ENDPOINT.basePath + "login/",
        headers: {},
        body: {
          username,
          password,
          role: "client",
        },
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  verifyOtp: (username, otp) => {
    return new Promise((resolve, reject) => {
      ApiPostServiceWrapper({
        url: API_ENDPOINT.basePath + "login/verify/otp",
        headers: {
          role: "",
        },
        body: {
          otp: otp,
          userName: username,
          appFlag: true,
        },
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  logout: () => {
    return new Promise((resolve, reject) => {
      const refHashId = secureStorage.getItem(SS_REF_HASH_ID);
      ApiPostServiceWithoutAuthenticationWrapper({
        url: API_ENDPOINT.basePath + "login/logout",
        headers: {},
        body: {
          refHashId,
        },
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  sendOtpForForgotPassword: (email) => {
    return new Promise((resolve, reject) => {
      ApiPostServiceWithoutAuthenticationWrapper({
        url: API_ENDPOINT.basePath + "authenticate/sendOtp",
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          email,
          role: "client",
        },
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  verifyOtpForgotPassword: (username, otp) => {
    return new Promise((resolve, reject) => {
      ApiPostServiceWithoutAuthenticationWrapper({
        url: API_ENDPOINT.basePath + "authenticate/verifyOtp",
        headers: {
          role: "",
        },
        body: {
          otp: otp,
          email: username,
        },
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  updateForgotPassword: (email, newPassword) => {
    return new Promise((resolve, reject) => {
      ApiPostServiceWithoutAuthenticationWrapper({
        url: API_ENDPOINT.basePath + "authenticate/updatePassword",
        headers: {},
        body: {
          email,
          newPassword,
        },
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  updateWebHookUrl: (notifyUrl = "", validateUrl = "", email, otp) => {
    return new Promise((resolve, reject) => {
      let refHashId = secureStorage.getItem(SS_REF_HASH_ID);

      ApiPutServiceWrapper({
        url: API_ENDPOINT.basePath + "client/update",
        headers: {
          "client-Hash-Id": refHashId,
        },
        body: {
          notifyUrl,
          validateUrl,
          email,
          otp,
        },
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getAllCustomers: (page = 0, size = 10, keyWord = "", clientHashId = "") => {
    return new Promise((resolve, reject) => {
      let refHashId = secureStorage.getItem(SS_REF_HASH_ID);
      ApiPostServiceWrapper({
        url: API_ENDPOINT.basePath + "client/customer/get",
        headers: {
          clientHashId: refHashId,
        },
        body: {
          page,
          size,
          keyWord,
          clientHashId: refHashId,
        },
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  getAllBeneficiary: (page = 0, size = 10, keyWord = "") => {
    return new Promise((resolve, reject) => {
      let refHashId = secureStorage.getItem(SS_REF_HASH_ID);
      ApiPostServiceWrapper({
        url: API_ENDPOINT.basePath + "beneficiary/list",
        headers: {
          clientHashId: refHashId,
        },
        body: {
          page,
          size,
          keyWord,
          clientHashId: refHashId,
        },
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  addCustomers: ({
    firstName = "",
    lastName = "",
    mobileNumber = "",
    bankDetails = [],
    closeByDate = "",
    autoCloseStatus = false,
    paymentDetails = [],
  }) => {
    return new Promise((resolve, reject) => {
      let refHashId = secureStorage.getItem(SS_REF_HASH_ID);
      ApiPostServiceWrapper({
        url: API_ENDPOINT.basePath + "client/customer",
        headers: {
          clientHashId: refHashId,
        },
        body: {
          firstName,
          lastName,
          mobileNumber,
          bankDetails,
          closeByDate,
          paymentDetails,
          autoCloseStatus,
        },
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  addScheduler: ({ schedulerName, emailId, startDate, type, frequency }) => {
    let refHashId = secureStorage.getItem(SS_REF_HASH_ID);
    let email = secureStorage.getItem(SS_EMAIL);
    return new Promise(async (resolve, reject) => {
      ApiPostServiceWrapper({
        url: API_ENDPOINT.basePath + "transaction/report/schedule",
        headers: {
          clientHashId: refHashId,
          userName: email,
        },
        body: {
          schedulerName,
          emailId,
          startDate: "2022-11-06",
          type: type?.toUpperCase(),
          frequency: frequency?.toUpperCase(),
        },
      })
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },

  pauseScheduler: (jobID) => {
    let refHashId = secureStorage.getItem(SS_REF_HASH_ID);
    return new Promise(async (resolve, reject) => {
      ApiPostServiceWrapper({
        url: API_ENDPOINT.basePath + "transaction/job/pause?jobId=" + jobID,
        body: {},
        headers: {
          clientHashId: refHashId,
        },
      })
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  resumeScheduler: (jobID) => {
    let refHashId = secureStorage.getItem(SS_REF_HASH_ID);
    return new Promise(async (resolve, reject) => {
      ApiPostServiceWrapper({
        url: API_ENDPOINT.basePath + "transaction/job/resume?jobId=" + jobID,
        body: {},
        headers: {
          clientHashId: refHashId,
        },
      })
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  deleteScheduler: (jobID) => {
    let refHashId = secureStorage.getItem(SS_REF_HASH_ID);
    return new Promise(async (resolve, reject) => {
      ApiDeleteServiceWrapper({
        url: API_ENDPOINT.basePath + "transaction/job/delete?jobId=" + jobID,
        body: {},
        headers: {
          clientHashId: refHashId,
        },
      })
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },

  generateReports: ({ fromDate = "", toDate = "", txnType = "" }) => {
    let refHashId = secureStorage.getItem(SS_REF_HASH_ID);
    return new Promise((resolve, reject) => {
      ApiPostServiceWrapper({
        url: API_ENDPOINT.basePath + "client/generate/report",
        body: {
          fromDate,
          toDate,
          txnType,
        },
        headers: {
          clientHashId: refHashId,
        },
      })
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },

  addCustomerBankAccount: ({
    accountNumber = "",
    ifscCode = "",
    customerHashId = "",
  }) => {
    let refHashId = secureStorage.getItem(SS_REF_HASH_ID);
    return new Promise((resolve, reject) => {
      ApiPostServiceWrapper({
        url: API_ENDPOINT.basePath + "customer/add/bank/account",
        body: {
          ifscCode,
          accountNumber,
        },
        headers: {
          "client-hash-id": refHashId,
          "customer-hash-id": customerHashId,
        },
      })
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },

  deleteCustomerBankAccount: ({
    accountNumber = "",
    ifscCode = "",
    customerHashId = "",
  }) => {
    let refHashId = secureStorage.getItem(SS_REF_HASH_ID);
    return new Promise((resolve, reject) => {
      ApiPostServiceWrapper({
        url: API_ENDPOINT.basePath + "customer/delete/bank/account",
        body: {
          ifscCode,
          accountNumber,
        },
        headers: {
          "client-hash-id": refHashId,
          "customer-hash-id": customerHashId,
        },
      })
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },

  customerTransactionHistory: (page, size, dateRange = "", paymentId) => {
    return new Promise((resolve, reject) => {
      const refHashId = secureStorage.getItem(SS_REF_HASH_ID);
      ApiPostServiceWrapper({
        url: API_ENDPOINT.basePath + "customer/upi/transaction",
        headers: {
          "client-hash-id": refHashId,
        },
        body: {
          page,
          size,
          dateRange,
          paymentId,
        },
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  updateCustomers: ({
    merchantName = "",
    mcc = "",
    brandName = "",
    legalName = "",
    franchise = "",
    merchantType = "",
    ownerShipType = "",
    genre = "",
    onboardingType = "",
    vpa = "",
    closeDate = "",
    autoClose = false,
    customerHashId,
  }) => {
    return new Promise((resolve, reject) => {
      let refHashId = secureStorage.getItem(SS_REF_HASH_ID);
      ApiPostServiceWrapper({
        url: API_ENDPOINT.basePath + "client/customer/update",
        headers: {
          clientHashId: refHashId,
          customerHashId,
        },
        body: {
          merchantName,
          mcc,
          brandName,
          legalName,
          franchise,
          merchantType,
          ownerShipType,
          genre,
          onboardingType,
          vpa,
          closeDate,
          autoClose,
        },
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  sendOtpForBeneficiary: ({ amount }) => {
    return new Promise((resolve, reject) => {
      const refHashId = secureStorage.getItem(SS_REF_HASH_ID);
      ApiPostServiceWrapper({
        url: API_ENDPOINT.basePath + "beneficiary/sendOtp",
        headers: {},
        body: {
          clientHashId: refHashId,
          amount,
        },
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  verifyOtpForBeneficiary: ({ otp }) => {
    return new Promise((resolve, reject) => {
      const refHashId = secureStorage.getItem(SS_REF_HASH_ID);
      ApiPostServiceWrapper({
        url: API_ENDPOINT.basePath + "beneficiary/verifyOtp",
        headers: {},
        body: {
          clientHashId: refHashId,
          otp,
        },
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  addBeneficiaryAndSendMoney: ({
    beneficiaryName,
    accountNumber,
    ifscCode,
    amount,
    type,
  }) => {
    return new Promise((resolve, reject) => {
      const refHashId = secureStorage.getItem(SS_REF_HASH_ID);
      ApiPostServiceWrapper({
        url: API_ENDPOINT.basePath + "beneficiary/payOut",
        headers: {
          "client-hash-id": refHashId,
        },
        body: {
          beneficiaryName,
          accountNumber,
          ifscCode,
          amount,
          type,
          creditorInfoRemarks: "Payouts",
        },
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  beneficiaryTransactionHistory: ({ accountNumber }) => {
    return new Promise((resolve, reject) => {
      const refHashId = secureStorage.getItem(SS_REF_HASH_ID);
      ApiPostServiceWrapper({
        url: API_ENDPOINT.basePath + "beneficiary/transaction",
        headers: {},
        body: {
          clientHashId: refHashId,
          accountNumber,
        },
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  verifyWithoutOtp: ({ username = "", password = "" }) => {
    return new Promise((resolve, reject) => {
      ApiPostServiceWrapper({
        url: API_ENDPOINT.basePath + "login/client",
        headers: {},
        body: {
          username,
          password,
          role: "client",
        },
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};
